import { render, staticRenderFns } from "./ClientPageFullPage.vue?vue&type=template&id=1690cd41&"
import script from "./ClientPageFullPage.vue?vue&type=script&lang=js&"
export * from "./ClientPageFullPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports